// Strip our own tracking artifacts from email HTML before rendering it in the
// OS. Two reasons:
//   1. Viewing your own sent mail must not fire the open pixel — the iframe
//      loads the <img> like any client would, which would record a fake open.
//   2. Links rewritten through /api/track-click should display (and copy) as
//      their real destination inside the OS.
// Handles pixels/links written by both the OS send path (gmail-send.js) and
// the Chrome extension (chatrone-tracker).
export function stripTrackingArtifacts(html) {
  if (!html || typeof html !== 'string') return html
  let out = html
  // Remove open-tracking pixels (any host — match on the endpoint path)
  out = out.replace(/<img[^>]*\/api\/track-open[^>]*\/?>/gi, '')
  // Unwrap click-tracking links back to the original URL.
  // Format: href="https://…/api/track-click?tid=…&url=<encoded>"
  out = out.replace(
    /href=(["'])[^"']*\/api\/track-click\?[^"']*?url=([^"'&]+)[^"']*\1/gi,
    (match, quote, encoded) => {
      try { return `href=${quote}${decodeURIComponent(encoded)}${quote}` } catch { return match }
    }
  )
  return out
}
